import script from "./AccueilView.vue?vue&type=script&setup=true&lang=js"
export * from "./AccueilView.vue?vue&type=script&setup=true&lang=js"

import "./AccueilView.vue?vue&type=style&index=0&id=2de41a76&lang=css"

const __exports__ = script;

export default __exports__